<template>
  <div id="Renew">
    <main>
      <div class="page-header pb-10 page-header-dark bg-gradient-primary-to-secondary">
        <div class="container-fluid">
          <div class="page-header-content">
            <h1 class="page-header-title">
              <div class="page-header-icon">
                <i data-feather="activity"></i>
              </div>
              <span>Renew</span>
            </h1>
            <div class="page-header-subtitle">Account Subscription</div>
          </div>
        </div>
      </div>
      <div class="container-fluid mt-n10">
        <div class="row">
          <div class="col-md-12">
            <div class="card mb-4">
              <!-- <div class="card-header">DataTable Example</div> -->
              <div class="card-body">
                <p>Name: {{authUser.name }}</p>
                <p>Email: {{authUser.email }}</p>
                <p>Institution: {{client.name}}</p>

                <div v-show="showPayButton">
                  <paystack :amount="amount" :email="authUser.email" :paystackkey="paystackkey" :reference="reference" :callback="callback" :close="close" :embed="false" class="btn btn-danger">Pay ₦{{amount/100 | thousandSeparator}}</paystack>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </main>
  </div>
</template>

<script>
import paystack from "vue-paystack";
import axios from "axios";

export default {
  name: "Renew",

  data() {
    return {
      showPayButton: true,
      amount: 125000 * 100,
      paystackkey: process.env.VUE_APP_PAYSTACK,
    };
  },

  computed: {
    authUser() {
      return this.$store.state.authUser;
    },
    client() {
      return this.$store.state.client;
    },

    reference() {
      let text = "";
      let possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
      for (let i = 0; i < 10; i++) text += possible.charAt(Math.floor(Math.random() * possible.length));
      return text;
    },
  },

  methods: {
    callback(response) {
      let formData = new FormData();
      formData.append("reference", response.reference);
      formData.append("transaction", response.transaction);
      formData.append("gateway", "paystack");
      formData.append("environment", process.env.VUE_APP_PAYMENT);

      axios.post("/admin/payment/check", formData).then((res) => {
        if (res.data.status === "success") {
          this.$swal("Done!", res.data.message, "success");
          this.$router.push({ name: "Transactions" });
        } else {
          this.$swal("Done!", res.data.message, "error");
        }
      });
      //this.$swal("Done!", response.message, "success");
      this.showPayButton = false;
    },
    close() {
      this.$swal("Closed!", "Payment closed", "warning");
    },
  },

  components: {
    paystack,
  },
};
</script>